<!--
/*******************************************************************************
*@ 컴포넌트명   : 
*@ 컴포넌트설명 : 
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="transfer mmqr">
    <popup :opened.sync="openData" :use-header="true" :use-footer="true" class="popup" @cancel="popupClose">
      <template #subtitle>
        <h2>{{ /*MMQR 결제상세정보*/ $t("MPAY-07-01-01-11") }}</h2>
      </template>
      <template #content>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /*거래 신청일시*/ $t("MPAY-07-01-01-15") }}</dt>
          <dd class="right">{{ $getGlobalDateFmt(_.padEnd(detailInfo.pyaccYMS, 20, " ")) }}</dd>

          <dt>{{ /*처리 상태*/ $t("MPAY-07-01-01-19") }}</dt>
          <dd v-if="detailInfo.tranPrgrsDsticName == 'Failed' 
          || detailInfo.tranPrgrsDsticName == '(Refund)Failed'
          || detailInfo.tranPrgrsDsticName == 'Error' " class="right warning">{{ detailInfo.tranPrgrsDsticName }}</dd>
          <dd v-else class="right normal">{{ detailInfo.tranPrgrsDsticName }}</dd>

          <dt>{{ /*결제방법*/ $t("MPAY-07-01-01-14") }}</dt>
          <!-- <dd class="right">{{ $t(`${detailInfo.sumry}_입출근거적요코드`) }}</dd> -->
          <dd v-if="'1|3|4|9'.includes(detailInfo.tranPrgrsDstcd)" class="right">{{ $t("MPAY-07-01-01-60") }}</dd>
          <dd v-else class="right">{{ $t("MPAY-07-01-01-64") }}</dd>

          <dt>{{ /*계좌번호*/ $t("MPAY-07-01-01-18") }}</dt>
          <dd class="right">{{ $maskAccNoByMMQR(detailInfo.drwotAcno) }}</dd>
          
          <dt>{{ /*거래 ID*/ $t("MPAY-07-01-01-13") }}</dt>
          <dd class="right">{{ detailInfo.tranID }}</dd>

          <dt>{{ /*MMQR 레퍼런스 ID*/ $t("MPAY-07-01-01-04") }}</dt>
          <dd class="right">{{ detailInfo.refID }}</dd>

          <dt>{{ /*판매자 계좌번호*/ $t("MPAY-07-01-01-22") }}</dt>
          <dd class="right">{{ $maskAccNoByMMQR(detailInfo.mnrcvAcno) }}</dd>

          <dt>{{ /*판매자*/ $t("MPAY-07-01-01-21") }}</dt>
          <dd class="right">{{ detailInfo.draweName }}</dd>
          
          <template v-if="'5|6|7'.includes(detailInfo.tranPrgrsDstcd)">
            <dt>{{ /*원금*/ $t("MPAY-07-01-01-65") }}</dt>
            <dd class="right">
              <span class="exchange-unit">{{ detailInfo.cncycd }}</span>
              <span class="amount">{{ $num(detailInfo.orgTranAmt) }}</span>
            </dd>
          </template>

          <dt>{{ /*금액*/ $t("MPAY-07-01-01-24") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.cncycd }}</span>
            <span class="amount">{{ $num(detailInfo.pyaccAmt) }}</span>
          </dd>

          <dt>{{ /*수수료*/ $t("MPAY-07-01-01-23") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.cncycd }}</span>
            <span class="amount">{{ $num(detailInfo.fee) }}</span>
          </dd>

          <dt>{{ /*메모*/ $t("MPAY-07-01-01-25") }}</dt>
          <dd class="right align-right">{{ "5|6|7".includes(detailInfo.tranPrgrsDstcd) ?  $t(`217_입출근거적요코드`) : detailInfo.draweRefCtnt }}</dd>

          <template v-if="detailInfo.qrDstcd == 1">
            <dt>{{ /*참조 번호*/ $t("MPAY-07-01-01-08") }}</dt>
            <dd class="right anywhere">{{ detailInfo.refNo }}</dd>

            <dt>{{ /*청구서 번호*/ $t("MPAY-07-01-01-09") }}</dt>
            <dd class="right anywhere">{{ detailInfo.billNo }}</dd>

            <dt>{{ /*목적*/ $t("MPAY-07-01-01-26") }}</dt>
            <dd class="right anywhere">{{ detailInfo.tranPurpose }}</dd>
          </template>

          <template v-if="'4|6'.includes(detailInfo.tranPrgrsDstcd)">
            <dt>{{ /*거절 사유*/ $t("MPAY-07-01-01-16") }}</dt>
            <dd class="right align-right anywhere">{{ detailInfo.rejcnResn }}</dd>
          </template>

          <template v-if="'5|6|7'.includes(detailInfo.tranPrgrsDstcd)">
            <dt>{{ /*환불 사유*/ $t("MPAY-07-01-01-17") }}</dt>
            <dd class="right align-right anywhere">{{ detailInfo.refndResn }}</dd>
          </template>
        </dl>
        <div class="align-center mtop-24 mbtm-24">
          <i class="icon img-mmqr-logo" />
          <span class="v-hidden">MyanmarPay <em>MMQR</em></span>
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="popupClose()">{{ /*뒤로*/ $t("MPAY-07-01-01-59") }}</button>
      </template>
    </popup>
  </section>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapFields(["siteCode", "operGroupCd"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    popupClose() {
      this.openData = false;
      this.$emit("popupClose", false);
    },
  },
};
</script>
